/* unplugin-vue-components disabled */import { render } from "./FillInTheBlanksQuestionEdit.vue?vue&type=template&id=25a88dc6&scoped=true&ts=true"
import script from "./FillInTheBlanksQuestionEdit.vue?vue&type=script&lang=ts"
export * from "./FillInTheBlanksQuestionEdit.vue?vue&type=script&lang=ts"

import "./FillInTheBlanksQuestionEdit.vue?vue&type=style&index=0&id=25a88dc6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25a88dc6"]])

export default __exports__